import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import 'react-toggle/style.css' // for ES6 modules
import Toggle from 'react-toggle'
import axios from 'axios'
import Constant, { getHourSlots } from '../../Constant'
import Moment from 'react-moment'
import 'react-responsive-modal/styles.css'
import ActivitiesController from '../../common/activitiesController/ActivitiesController'
import Button from '../../common/CustomComponents/Button'
import Select from 'react-select'
import moment from 'moment'
import Loader from '../../common/Loader'
import CustomFooter from '../../common/TableBottom'
// import { Button } from '@material-ui/core'
// import CheckPermission from '../../common/Permissions/CheckPermission'
// import { Modal } from 'react-responsive-modal'

class BoatsList extends React.Component {
  state = {
    Products_data: [],
    isloading: false,
    isEditing: false,
    isPopularOrderEdit: false,
    isTopPickOrderEdit: false,
    cat: this.props.match.params.boatType,
    excelFile: '',
    image_excel: '',
    excelUploadErrors: [],
    // isModalOpen: false,
    // pushId: '',
    // pushTitle: '',
    // pushMessage: '',
    keyword: '',
    price: '',
    facilityData: [],
    facilityList: [],
    pickupData: null,
    pickupList: [],
    destinationData: null,
    destinationList: [],
    date: '',
    start_time: '',
    end_time: '',
    limit: 10,
    pageNumber: 0,
    totalCount: 0,
    totalPages: 0,
    disabled: false,
    isSearching: false,
    open: false,
  }

  debounceTimeout = null

  handleStatusChange = async (id, isActive, name) => {
    var data = {}
    if (name == 'is_top_pick') {
      data = {
        cruiseId: id,
        is_top_pick: isActive,
      }
    } else if (name === 'offer') {
      data = {
        cruiseId: id,
        offer: isActive,
      }
    } else if (name === 'popular_choice') {
      data = {
        cruiseId: id,
        popular_choice: isActive,
      }
    } else {
      data = {
        cruiseId: id,
        is_active: isActive,
      }

      if (!isActive) {
        const { value: reason, isConfirmed } = await Swal.fire({
          title: 'Why are you deactivating this cruise?',
          input: 'select',
          inputOptions: {
            'Under Maintenance': 'Under Maintenance',
            'Approval of Quality': 'Approval of Quality',
            'Request from the owner': 'Request from the owner',
            'Missing facilities / prices Data': 'Missing facilities / prices Data',
            'Reshooting is required': 'Reshooting is required',
            'Cleaning concerns': 'Cleaning concerns',
            Other: 'Other',
          },
          inputPlaceholder: 'Select a reason',
          showCancelButton: true,
          confirmButtonText: 'Submit',
        })

        if (!isConfirmed) {
          return
        }

        data.status_reason = reason
      }
    }

    await axios
      .put(Constant.getAPI() + '/cruise/update-cruise-status', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Updated !', 'Status has been Changed', 'success')
          this.dashbord()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleExcelChange = (e) => {
    const reader = new FileReader()
    const name = e.target.name

    if (e.target.files && e.target.files.length) {
      const file = e.target.files[0]
      reader.readAsDataURL(file)
      reader.onloadend = () => {
        this.setState({
          [name]: reader.result,
        })
      }
    } else {
      this.setState({
        [name]: '',
      })
    }
  }

  submitExcel = async () => {
    // let storeProductId = this.props.match.params.storeDetail_id
    if (this.state.excelFile) {
      this.setState({ isLoading: true })
      localStorage.setItem('isLoading', true)
      const data = {
        file: this.state.excelFile,
        // storeProductId,
      }

      await axios
        .post(Constant.getAPI() + '/admin/meta-boat-excel-import', data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState(
            {
              isLoading: false,
              excelFile: '',
              excelUploadErrors: res?.data?.data?.error || [],
            },
            () => {
              this.image_excel.value = null
            }
          )
          Swal.fire({
            title: 'Cruise Details Updated Successfully!',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })

          // this.ProductStoreList()
        })
        .catch((err) => {
          this.setState({ isLoading: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
        .finally(() => {
          localStorage.setItem('isLoading', false)
        })
    }
  }

  downloadSampleProductListExcelFile = async () => {
    await axios
      .get(Constant.getAPI() + '/admin/meta-details-excel-export', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then(async (res) => {
        const data = res.data.data
        this.exportFile = Constant.getImage() + data.file
        this.fileName = data.fileName
        const a = document.createElement('a')
        a.href = this.exportFile
        a.download = this.fileName
        a.click()
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getCategoryListExcelFile = async () => {
    await axios
      .get(Constant.getAPI() + '/admin/get-meta-list-excel-export', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then(async (res) => {
        const data = res.data.data
        this.exportFile = Constant.getImage() + data.file
        this.fileName = data.fileName
        const a = document.createElement('a')
        a.href = this.exportFile
        a.download = this.fileName
        a.click()
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  componentDidMount() {
    this.getFacilities()
    this.getPickup()
    this.getDestination()
    this.dashbord()
  }

  componentWillUnmount() {
    // Clear timeout on unmount
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout)
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState(
      {
        cat: this.props?.match?.params?.boatType,
      },
      () => {
        if (nextProps.findPerson === 'UpdatingDom') {
          this.setState({
            Products_data: [],
          })
          this.dashbord()
        }
      }
    )
  }

  dashbord = async () => {
    if (this.state.date && (!this.state.start_time || !this.state.end_time)) {
      Swal.fire('Please select start/end time!', '', 'error')
      return
    }

    this.setState({
      isloading: true,
      isSearching: true,
      open: true,
      Products_data: [],
    })

    await axios
      .get(
        Constant.getAPI() +
          `/cruise/cruise-listing/${this.props?.match?.params?.boatType || this.state.cat}/${this.props?.match?.params?.typeId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
          params: {
            keyword: this.state.keyword,
            price: this.state.price,
            facilities: this.state.facilityData?.map((ele) => ele.value)?.join(','),
            pickup: this.state.pickupData?.value,
            destination: this.state.destinationData?.value,
            date: this.state.date,
            start_time: this.state.start_time,
            end_time: this.state.end_time,
            limit: this.state.limit,
            pageNumber: this.state.pageNumber,
          },
        }
      )
      .then((res) => {
        if (res.data.success) {
          this.setState({
            Products_data: res.data.data,
            open: false,
            totalCount: res.data.pagination?.count || 0,
            totalPages: res.data.pagination?.pages || 0,
            disabled: this.state?.pageNumber + 1 >= res?.data?.pagination?.pages,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
        this.setState({
          open: false,
        })
      })
      .finally(() => {
        this.setState({
          isloading: false,
          isSearching: false,
        })
      })
  }

  onEdit = (selectedId, order, type) => {
    if (type == 'topPick') {
      this.setState({
        isPopularOrderEdit: false,
        isTopPickOrderEdit: true,
        isEditing: false,

        selectedId,
        top_pick_order: order,
      })
    } else if (type == 'popular') {
      this.setState({
        isPopularOrderEdit: true,
        isTopPickOrderEdit: false,
        isEditing: false,

        selectedId,
        popular_choice_order: order,
      })
    } else {
      this.setState({
        isPopularOrderEdit: false,
        isTopPickOrderEdit: false,
        isEditing: true,

        selectedId,
        order,
      })
    }
  }

  onChangeSort = (selectedId, type) => {
    var data = {
      cruise_id: selectedId,
    }

    this.setState({ isPopularOrderEdit: false, isEditing: false, isTopPickOrderEdit: false })

    if (type == 'topPick') {
      data.top_pick_order = parseInt(this.state.top_pick_order)
      data.order_type = 'topPick'
    } else if (type == 'popular') {
      data.popular_choice_order = parseInt(this.state.popular_choice_order)
      data.order_type = 'popular'
    } else {
      data.order = parseInt(this.state.order)
    }

    axios
      .put(Constant.getAPI() + '/cruise/update-cruise-priority', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then(() => {
        this.dashbord()
      })
      .catch(() => {})
  }

  onInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }

  // onPushClick = (id) => {
  //   // this.setState({
  //   //   isModalOpen: true,
  //   //   pushTitle: metaData.rowData[2].slice(0, 22),
  //   //   pushId: id,
  //   // })
  //   let cruise = this.state.Products_data.find((item) => item.id == id)

  //   Swal.fire({
  //     title: 'Are you sure to send the notification regarding this item?',
  //     showDenyButton: true,
  //     showCancelButton: true,
  //     confirmButtonText: `Yes`,
  //     denyButtonText: `No`,
  //   }).then(async (result) => {
  //     if (result.isConfirmed) {
  //       await axios
  //         .post(
  //           Constant.getAPI() + '/admin/send-pushwoosh',
  //           {
  //             type: 'Y',
  //             target_id: id,
  //             name_en: cruise.cruise_name_en,
  //             name_ar: cruise.cruise_name_ar,
  //             selected_country: localStorage.getItem('countryShortName') || 'KWT',
  //           },
  //           {
  //             headers: {
  //               Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
  //               country_short_name: `${localStorage.getItem('countryShortName')}`,
  //             },
  //           }
  //         )
  //         .then((res) => {
  //           if (res.status === 200) {
  //             Swal.fire('Notification Sent !', '', 'success')
  //           }
  //         })
  //         .catch((err) => {
  //           if (err?.response?.status === 401) {
  //             Constant.getAuthLogout()
  //           } else {
  //             Swal.fire({
  //               title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
  //               icon: 'error',
  //               text: '',
  //               type: 'error',
  //               confirmButtonColor: '#3085d6',
  //               cancelButtonColor: '#d33',
  //               confirmButtonText: 'Ok',
  //             })
  //           }
  //         })
  //     }
  //   })
  // }

  // onModalClose = () => {
  //   this.setState({
  //     pushId: '',
  //     pushTitle: '',
  //     pushMessage: '',
  //     isModalOpen: false,
  //   })
  // }

  // sendPush = () => {
  //   this.setState({ isData: true })

  //   if (!this.state.pushTitle || !this.state.pushMessage) {
  //     Swal.fire({
  //       title: 'Error',
  //       icon: 'error',
  //       text: 'All fields are required...',
  //       type: 'error',
  //       confirmButtonColor: '#3085d6',
  //       cancelButtonColor: '#d33',
  //       confirmButtonText: 'Ok',
  //     })

  //     this.setState({ isData: false })
  //     return
  //   }

  //   const data = {
  //     pushTitle: this.state.pushTitle,
  //     message: this.state.pushMessage,
  //     type: 'Y',
  //     typeId: this.state.pushId,
  //   }

  //   axios
  //     .post(Constant.getAPI() + '/admin/send-push', data, {
  //       headers: {
  //         Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
  //         country_short_name: `${localStorage.getItem('countryShortName')}`,
  //       },
  //     })
  //     .then((res) => {
  //       this.setState({ isData: false })
  //       if (res.status) {
  //         Swal.fire({
  //           title: 'Notification sent Successfully!',
  //           icon: 'success',
  //           text: '',
  //           type: 'success',
  //           confirmButtonColor: '#3085d6',
  //           cancelButtonColor: '#d33',
  //           confirmButtonText: 'Ok',
  //         })
  //         this.onModalClose()
  //       }
  //     })
  //     .catch((err) => {
  //       this.setState({ isData: false })
  //       if (err?.response?.status === 401) {
  //         Constant.getAuthLogout()
  //       } else {
  //         Swal.fire({
  //           title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
  //           icon: 'error',
  //           text: '',
  //           type: 'error',
  //           confirmButtonColor: '#3085d6',
  //           cancelButtonColor: '#d33',
  //           confirmButtonText: 'Ok',
  //         })
  //       }
  //     })
  // }

  getFacilities = async () => {
    await axios
      .get(Constant.getAPI() + `/admin/get-facilities/cruise`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            facilityList: res?.data?.data?.map((ele) => {
              return { label: `${ele.name_en}/${ele.name_ar}`, value: ele.id }
            }),
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getPickup = async () => {
    await axios
      .get(Constant.getAPI() + `/admin/pick-up-listing`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            pickupList: res?.data?.data?.map((ele) => {
              return { label: `${ele.pickup_address_en}/${ele.pickup_address_ar}`, value: ele.id }
            }),
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getDestination = async () => {
    await axios
      .get(Constant.getAPI() + `/admin/list-destinations`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            destinationList: res?.data?.data?.map((ele) => {
              return { label: `${ele.destination_address_en}/${ele.destination_address_ar}`, value: ele.id }
            }),
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      this.searchData()
    }
  }

  handleChange = (event) => {
    event.persist()
    const fieldName = event?.target?.name
    const fieldValue = event?.target?.value

    this.setState({
      [fieldName]: fieldValue,
    })

    // Auto-search with debounce for keyword field
    if (fieldName === 'keyword') {
      if (this.debounceTimeout) clearTimeout(this.debounceTimeout)

      this.debounceTimeout = setTimeout(() => {
        this.setState(
          {
            pageNumber: 0,
          },
          () => {
            this.dashbord()
          }
        )
      }, 500)
    }
  }

  handleFacilityChange = (event) => {
    this.setState({
      facilityData: event,
    })
  }

  handlePickupChange = (event) => {
    this.setState({
      pickupData: event,
    })
  }

  handleDestinationChange = (event) => {
    this.setState({
      destinationData: event,
    })
  }

  handlePickupClear = () => {
    this.setState({ pickupData: {} })
  }

  handleDestinationClear = () => {
    this.setState({ destinationData: {} })
  }

  handleClear = () => {
    this.setState({ facilityData: [] })
  }

  searchData = async () => {
    this.setState(
      {
        Products_data: [],
      },
      () => {
        this.dashbord()
      }
    )
  }

  clearFilters = () => {
    this.setState(
      {
        facilityData: [],
        pickupData: null,
        destinationData: null,
        date: '',
        start_time: '',
        end_time: '',
        keyword: '',
        price: '',
        limit: 10,
        pageNumber: 0,
        Products_data: [],
      },
      () => {
        this.dashbord()
      }
    )
  }

  onSearch = (event) => {
    this.setState(
      {
        keyword: event.target.value,
        pageNumber: 0,
      },
      () => {
        if (this.debounceTimeout) clearTimeout(this.debounceTimeout)

        this.debounceTimeout = setTimeout(() => {
          this.dashbord()
        }, 500)
      }
    )
  }

  clearSearch = () => {
    this.setState(
      {
        keyword: '',
        pageNumber: 0,
      },
      () => {
        this.dashbord()
      }
    )
  }

  render() {
    const customSearchRender = (searchText, handleSearch, hideSearch) => {
      return (
        <div className="container">
          <div className="d-flex justify-content-around">
            <i className="f-16 icofont icofont-search m-t-10 m-r-10"></i>
            <input
              type="search"
              className="form-control custom-input-search"
              placeholder="Search"
              value={this.state.keyword}
              name="keyword"
              onChange={this.onSearch}
            />
            <span
              className="pointer m-t-5"
              style={{ cursor: 'pointer' }}
              onClick={() => {
                this.clearSearch(hideSearch)
              }}
            >
              <i className="f-24 icofont icofont-close m-l-10"></i>
            </span>
          </div>
        </div>
      )
    }

    const columns = [
      {
        name: 'id',
        label: 'Cruise Id',
        options: {
          filter: false,
          sort: false,
          display: false,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'cruise_large_img',
        label: 'Image',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (cruise_large_img) => {
            return (
              <div>
                {cruise_large_img !== null ? (
                  <div>
                    {cruise_large_img?.indexOf('.mp4') !== -1 ? (
                      <video
                        width="250"
                        controls
                      >
                        <source
                          src={
                            cruise_large_img !== undefined && cruise_large_img !== null && cruise_large_img !== {}
                              ? Constant.getImage() + cruise_large_img
                              : './assets/images/icon.png'
                          }
                          type="video/mp4"
                        />
                      </video>
                    ) : (
                      <img
                        src={cruise_large_img ? Constant.getImage() + cruise_large_img : './assets/images/icon.png'}
                        className="img-fluid img-40"
                        alt="tbl"
                        onError={(event) => {
                          event.currentTarget.src = './assets/images/no_image.png'
                        }}
                      />
                    )}
                  </div>
                ) : (
                  <img
                    src={
                      cruise_large_img !== undefined && cruise_large_img !== null && cruise_large_img !== {}
                        ? Constant.getImage() + cruise_large_img
                        : './assets/images/icon.png'
                    }
                    className="img-fluid img-40"
                    alt="tbl"
                    onError={(event) => {
                      event.currentTarget.src = './assets/images/no_image.png'
                    }}
                  />
                )}
              </div>
            )
          },
        },
      },
      {
        name: 'cruise_name_en',
        label: `${this.props.match.params.boatType}Name:English`,
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta) => {
            const id = tableMeta.rowData[0]
            const cruise = this.state.Products_data.find((item) => item.id === id)
            const hasWarnings = cruise?.hasWarnings
            const warnings = cruise?.warnings || []

            return (
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span>{value}</span>
                {hasWarnings && warnings.length > 0 && (
                  <span
                    title={warnings.join('\n')}
                    style={{
                      cursor: 'pointer',
                      color: '#ff9800',
                      fontSize: '18px',
                      position: 'relative',
                    }}
                    onClick={() => {
                      Swal.fire({
                        title: 'Warnings',
                        html: `<div style="text-align: left;">${warnings
                          .map((warning) => `<p style="margin: 8px 0;">⚠️ ${warning}</p>`)
                          .join('')}</div>`,
                        icon: 'warning',
                        confirmButtonText: 'Ok',
                        confirmButtonColor: '#ff9800',
                      })
                    }}
                  >
                    <i className="icofont icofont-warning-alt"></i>
                  </span>
                )}
              </div>
            )
          },
        },
      },
      {
        name: 'cruise_name_ar',
        label: `${this.props.match.params.boatType}Name:Arabic`,
        options: {
          filter: true,
          sort: true,
          display: false,
        },
      },
      {
        name: 'ownerName',
        label: 'Owner',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'cruise_mobile_number',
        label: 'Mobile number',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'captainName',
        label: 'CaptainAssign',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'minimum_booking_time',
        label: 'Minimum BookingTime',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'updatedAt',
        label: 'Date',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (date) => {
            return (
              <div>
                <Moment format="DD/MM/YYYY">{date}</Moment>
              </div>
            )
          },
        },
      },
      {
        name: 'updatedAt',
        label: 'Time(hrs:min:sec)',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (date) => {
            return (
              <div>
                <Moment format="HH:mm:ss">{date}</Moment>
              </div>
            )
          },
        },
      },
      {
        name: 'order',
        label: 'Order',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (order, tableMeta) => {
            var id = tableMeta.rowData[0]
            return (
              <div className="form-group">
                <div className="form-group">
                  <div className="input-group mb-3">
                    {this.state.isEditing ? (
                      this.state.selectedId === id ? (
                        <input
                          type="text"
                          name="order"
                          className="form-control px-1 form-control-sm"
                          style={{ width: '50px' }}
                          onChange={this.onInputChange}
                          value={this.state.order}
                        />
                      ) : (
                        <div
                          className="form-control"
                          style={{ width: '50px' }}
                        >
                          {order}
                        </div>
                      )
                    ) : (
                      <div
                        className="form-control"
                        style={{ width: '50px' }}
                      >
                        {order}
                      </div>
                    )}{' '}
                    <div className="input-group-append border">
                      {this.state.isEditing ? (
                        this.state.selectedId === id ? (
                          <span
                            className="input-group-text d-flex justify-content-center align-items-center   shadow-sm"
                            onClick={this.onChangeSort.bind(this, id)}
                          >
                            <i className="f-15 bg-white p-2 icofont icofont-ui-check"></i>
                          </span>
                        ) : (
                          <span
                            className="input-group-text d-flex justify-content-center align-items-center   shadow-sm"
                            onClick={this.onEdit.bind(this, id, order)}
                          >
                            <i className="f-15 bg-white p-2 icofont icofont-ui-edit text-custom"></i>
                          </span>
                        )
                      ) : (
                        <span
                          className="input-group-text d-flex justify-content-center align-items-center   shadow-sm"
                          onClick={this.onEdit.bind(this, id, order)}
                        >
                          <i className="f-15 bg-white p-2 icofont icofont-ui-edit text-custom"></i>
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )
          },
        },
      },
      {
        name: 'popular_choice_order',
        label: 'Popular Choice Order',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (order, tableMeta) => {
            var id = tableMeta.rowData[0]
            return (
              <div className="form-group">
                <div className="form-group">
                  <div className="input-group mb-3">
                    {this.state.isPopularOrderEdit ? (
                      this.state.selectedId === id ? (
                        <input
                          type="text"
                          name="popular_choice_order"
                          className="form-control px-1 form-control-sm"
                          style={{ width: '50px' }}
                          onChange={this.onInputChange}
                          value={this.state.popular_choice_order}
                        />
                      ) : (
                        <div
                          className="form-control"
                          style={{ width: '50px' }}
                        >
                          {order}
                        </div>
                      )
                    ) : (
                      <div
                        className="form-control"
                        style={{ width: '50px' }}
                      >
                        {order}
                      </div>
                    )}{' '}
                    <div className="input-group-append border">
                      {this.state.isPopularOrderEdit ? (
                        this.state.selectedId === id ? (
                          <span
                            className="input-group-text d-flex justify-content-center align-items-center   shadow-sm"
                            onClick={this.onChangeSort.bind(this, id, 'popular')}
                          >
                            <i className="f-15 bg-white p-2 icofont icofont-ui-check"></i>
                          </span>
                        ) : (
                          <span
                            className="input-group-text d-flex justify-content-center align-items-center   shadow-sm"
                            onClick={this.onEdit.bind(this, id, order, 'popular')}
                          >
                            <i className="f-15 bg-white p-2 icofont icofont-ui-edit text-custom"></i>
                          </span>
                        )
                      ) : (
                        <span
                          className="input-group-text d-flex justify-content-center align-items-center   shadow-sm"
                          onClick={this.onEdit.bind(this, id, order, 'popular')}
                        >
                          <i className="f-15 bg-white p-2 icofont icofont-ui-edit text-custom"></i>
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )
          },
        },
      },
      {
        name: 'popular_choice',
        label: 'Popular Choice',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta) => {
            return (
              <Toggle
                id={tableMeta.rowData[0]}
                checked={value === true ? true : false}
                value={value}
                onChange={this.handleStatusChange.bind(this, tableMeta.rowData[0], !value, 'popular_choice')}
              />
            )
          },
        },
      },
      {
        name: 'top_pick_order',
        label: 'Top Pick Order',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (order, tableMeta) => {
            var id = tableMeta.rowData[0]

            return (
              <div className="form-group">
                <div className="form-group">
                  <div className="input-group mb-3">
                    {this.state.isTopPickOrderEdit ? (
                      this.state.selectedId === id ? (
                        <input
                          type="text"
                          name="top_pick_order"
                          className="form-control px-1 form-control-sm"
                          style={{ width: '50px' }}
                          onChange={this.onInputChange}
                          value={this.state.top_pick_order}
                        />
                      ) : (
                        <div
                          className="form-control"
                          style={{ width: '50px' }}
                        >
                          {order}
                        </div>
                      )
                    ) : (
                      <div
                        className="form-control"
                        style={{ width: '50px' }}
                      >
                        {order}
                      </div>
                    )}{' '}
                    <div className="input-group-append border">
                      {this.state.isTopPickOrderEdit ? (
                        this.state.selectedId === id ? (
                          <span
                            className="input-group-text d-flex justify-content-center align-items-center   shadow-sm"
                            onClick={this.onChangeSort.bind(this, id, 'topPick')}
                          >
                            <i className="f-15 bg-white p-2 icofont icofont-ui-check"></i>
                          </span>
                        ) : (
                          <span
                            className="input-group-text d-flex justify-content-center align-items-center   shadow-sm"
                            onClick={this.onEdit.bind(this, id, order, 'topPick')}
                          >
                            <i className="f-15 bg-white p-2 icofont icofont-ui-edit text-custom"></i>
                          </span>
                        )
                      ) : (
                        <span
                          className="input-group-text d-flex justify-content-center align-items-center   shadow-sm"
                          onClick={this.onEdit.bind(this, id, order, 'topPick')}
                        >
                          <i className="f-15 bg-white p-2 icofont icofont-ui-edit text-custom"></i>
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )
          },
        },
      },
      {
        name: 'is_top_pick',
        label: 'Top Pick',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta) => {
            return (
              <Toggle
                id={tableMeta.rowData[0]}
                checked={value === true ? true : false}
                value={value}
                onChange={this.handleStatusChange.bind(this, tableMeta.rowData[0], !value, 'is_top_pick')}
              />
            )
          },
        },
      },
      {
        name: 'offer',
        label: 'Offered Item',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta) => {
            return (
              <Toggle
                id={tableMeta.rowData[0]}
                checked={value === true ? true : false}
                value={value}
                onChange={this.handleStatusChange.bind(this, tableMeta.rowData[0], !value, 'offer')}
              />
            )
          },
        },
      },
      {
        name: 'is_active',
        label: 'Status',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (is_active, tableMeta) => {
            return (
              <Toggle
                id={tableMeta.rowData[0]}
                checked={is_active === true ? true : false}
                value={is_active}
                onChange={this.handleStatusChange.bind(this, tableMeta.rowData[0], !is_active, 'isActive')}
              />
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Actions',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (id) => {
            return (
              <div className="d-flex justify-content-end align-items-center">
                <Link
                  to={`/viewboat-details/${this.props.match.params.boatType}/` + id}
                  className="m-r-15 text-muted"
                >
                  <i className="f-22 icofont icofont-eye text-dark"></i>
                </Link>
                {/* <span
                  onClick={this.onPushClick.bind(this, id)}
                  className="m-r-15 text-muted"
                  style={{ cursor: 'pointer' }}
                >
                  <i className="f-20 icofont icofont-notification text-warning"></i>{' '}
                </span> */}
                <ActivitiesController refId={id}>Activities</ActivitiesController>
              </div>
            )
          },
        },
      },
    ]

    const options = {
      filterType: 'dropdown',
      viewColumns: false,
      print: false,
      download: false,
      search: false,
      filter: false,
      count: this.state.totalCount,
      page: this.state.pageNumber,
      rowsPerPage: this.state.limit,
      serverSide: true,
      selectableRows: 'none',
      customSearchRender: customSearchRender,
      onSearchClose: () => {
        this.clearSearch()
      },
      customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage) => {
        return (
          <CustomFooter
            changePage={changePage}
            changeRowsPerPage={changeRowsPerPage}
            disabled={this.state.disabled}
            count={this.state.limit}
            pageNumber={this.state.pageNumber}
            totalPages={this.state.totalPages}
          />
        )
      },
      onChangePage: (currentPage) => {
        this.setState(
          {
            pageNumber: currentPage,
          },
          () => this.dashbord()
        )
      },
      onChangeRowsPerPage: (numberOfRows) => {
        this.setState(
          {
            limit: numberOfRows,
            pageNumber: 0,
          },
          () => this.dashbord()
        )
      },
      textLabels: {
        body: {
          noMatch: this.state.open ? <Loader open={this.state.open} /> : 'Sorry, No Data Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <div className="pcoded-inner-content">
        {/* <Modal
          open={this.state.isModalOpen}
          onClose={this.onModalClose}
          center
        >
          <div className="card-body">
            <div className="row">
              <div className="col-12">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Title</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="pushTitle"
                      id="title"
                      placeholder="Title"
                      onChange={this.handleChange}
                      value={this.state.pushTitle}
                      maxLength="22"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Message</label>
                  <div className="col-sm-9">
                    <textarea
                      type="text"
                      className="form-control"
                      name="pushMessage"
                      id="message"
                      placeholder="Message"
                      onChange={this.handleChange}
                      value={this.state.pushMessage}
                      rows="4"
                      cols="50"
                      maxLength="53"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="text-right col-6 offset-6">
                {this.state.isData ? (
                  <button
                    className="btn btn-grd-disabled mr-2"
                    disabled
                  >
                    Sending...!
                  </button>
                ) : (
                  <button
                    onClick={this.sendPush}
                    className="btn hor-grd btn-grd-inverse offset-1"
                  >
                    <i className="ti-save"></i>Send
                  </button>
                )}
              </div>
            </div>
          </div>
        </Modal> */}
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>{this.props.match.params.boatType} List</h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title d-flex justify-content-end align-items-center">
                      <li className="mr-2">
                        <Button
                          to={`/boatsmaster/cruise/${this.props.match.params.boatType}/add`}
                          startIcon={<i className="icofont icofont-plus m-r-5"></i>}
                          className="f-right text-white"
                        >
                          Add
                        </Button>
                      </li>
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">{this.props.match.params.boatType} List</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="form-group row">
                          <label className="col-md-3 col-form-label">Search</label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              id="keyword"
                              className="form-control"
                              value={this.state.keyword}
                              name="keyword"
                              placeholder="Name | Description | Owner | Captain"
                              // onKeyPress={this.handleKeyPress}
                              onChange={this.handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group row">
                          <label className="col-md-3 col-form-label">Price search</label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              id="price"
                              className="form-control"
                              value={this.state.price}
                              name="price"
                              placeholder="Price"
                              // onKeyPress={this.handleKeyPress}
                              onChange={this.handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">Facility</label>
                          <div className="col-sm-9">
                            <Select
                              name="facilityData"
                              value={this.state.facilityData}
                              onChange={this.handleFacilityChange}
                              options={this.state.facilityList}
                              isMulti={true}
                              isSearchable={true}
                              isClearable
                              onClear={this.handleClear}
                              placeholder="Select Options"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">Pickup</label>
                          <div className="col-sm-9">
                            <Select
                              name="pickupData"
                              value={this.state.pickupData}
                              onChange={this.handlePickupChange}
                              options={this.state.pickupList}
                              isMulti={false}
                              isSearchable={true}
                              isClearable
                              onClear={this.handlePickupClear}
                              placeholder="Select Option"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">Destination</label>
                          <div className="col-sm-9">
                            <Select
                              name="destinationData"
                              value={this.state.destinationData}
                              onChange={this.handleDestinationChange}
                              options={this.state.destinationList}
                              isMulti={false}
                              isSearchable={true}
                              isClearable
                              onClear={this.handleDestinationClear}
                              placeholder="Select Option"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4"></div>
                      <div className="col-md-4">
                        <div className="form-group row">
                          <label className="col-md-3 col-form-label">Date</label>
                          <div className="col-md-9">
                            <input
                              type="date"
                              min={moment().format('YYYY-MM-DD')}
                              id="date"
                              className="form-control"
                              value={this.state.date}
                              name="date"
                              onChange={this.handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">Start Time</label>
                          <div className="col-sm-9">
                            <select
                              name="start_time"
                              className="form-control"
                              value={this.state.start_time}
                              onChange={this.handleChange}
                            >
                              <option>Select Start time(HH:MM)</option>
                              {getHourSlots().map(
                                (itm) => itm.value != '24:00:00' && <option value={itm.value}>{itm.label}</option>
                              )}
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">End Time</label>
                          <div className="col-sm-9">
                            <select
                              name="end_time"
                              className="form-control"
                              value={this.state.end_time}
                              onChange={this.handleChange}
                            >
                              <option>Select End time(HH:MM)</option>
                              {getHourSlots().map(
                                (itm) => itm.value != '24:00:00' && <option value={itm.value}>{itm.label}</option>
                              )}
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="row">
                          <div className="text-left col">
                            <Button
                              onClick={this.searchData}
                              disabled={this.state.isSearching}
                            >
                              {this.state.isSearching ? 'Searching...' : 'Search'}
                            </Button>
                            <Button
                              variant={'outlined'}
                              onClick={this.clearFilters}
                            >
                              Clear
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        {this.state?.isloading ? (
                          'loading...'
                        ) : (
                          <MUIDataTable
                            title={`${this.props.match.params.boatType} List`}
                            className="table-responsive"
                            data={this.state.Products_data}
                            columns={columns}
                            options={options}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default BoatsList
